
<n-modal-background @close="$emit('close')" ref="bg">
  <n-modal-body width="l">
    <NTitleBar :title="$t('planSettings.buttons.talkToNotch')" closable @close="$refs.bg.close()" class="title" />
    <iframe src="https://calendly.com/callnotch/notch-discovery?embed_domain=www.notch.so&amp;embed_type=Inline" />
  </n-modal-body>
</n-modal-background>
